import React from "react"
import FaIcon from "components/fa_icon"

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = {has_error: false}
  }

  static getDerivedStateFromError(_error) {
    return {has_error: true}
  }

  render() {
    if (this.state.has_error) return this.props.fallback

    return this.props.children
  }
}

export const LoadingErrorFallback = ({style}) => (
  <div className="image-loading-error" style={style}>
    <FaIcon name={"fa-exclamation-triangle"}/>
  </div>
)

export default ErrorBoundary
